import { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import axiosInstance from '../axiosConfig';
import './Checkout.css';
import { ReactComponent as WhiteLogo } from '../Assets/Images/White_Logo_Transparent.svg';
import TickerBar from './TickerBar';

const stripePromise = loadStripe(
  'pk_live_51Qm0eHI8JCfI67oE7e3bqBczfL2J9baolWACViRaig56iiut9p31IN5OJS0mwTe6bLJdsTmZuFpiJ7U7EJpTR3uO00CR2qge06'
);

const Checkout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const billingCycle = 'annual';

  // Lock scroll while on checkout + ensure we start at the top
  useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    window.scrollTo(0, 0);

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, []);

  const handleCheckout = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axiosInstance.post(
        '/create-checkout-session/',
        { billing_cycle: billingCycle },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('Checkout session created:', response.data);

      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe failed to initialize');
      }

      const { error } = await stripe.redirectToCheckout({
        sessionId: response.data.id,
      });

      if (error) {
        setError(error.message);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      setError(
        error.response?.data?.error || 'Error. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="checkout-root">
      {/* Stock ticker across the top */}
      <TickerBar />

      <div className="checkout-page">
        <div className="checkout-card">
          {/* Close / back icon */}
          <button
            className="checkout-close"
            onClick={() => (window.location.href = '/')}
            aria-label="Close"
          >
            ×
          </button>

          {/* Logo */}
          <div className="checkout-header">
            <WhiteLogo className="checkout-logo-svg" />
          </div>

          {/* Plan card (yearly only) */}
          <div className="plan-card">
            <div className="plan-card-main">
              <div>
                <div className="plan-name">Yearly Membership</div>
                <div className="plan-description">
                  Best for serious club research.
                </div>
              </div>
              <div className="plan-pricing">
                <div className="plan-price">$20</div>
                <div className="plan-price-detail">per year</div>
              </div>
            </div>
            <div className="plan-badge">Founding member rate</div>
          </div>

          {/* Benefits */}
          <ul className="plan-benefits">
            <li>Full access to 2,500+ private club profiles</li>
            <li>Shared intel on cost estimates</li>
            <li>Member community, message boards &amp; round sharing</li>
            <li>Exclusive discounts with select golf brands</li>
          </ul>

          {/* CTA */}
          <button
            onClick={handleCheckout}
            disabled={loading}
            className="checkout-button"
          >
            {loading ? (
              <span className="checkout-loading">
                <span>Processing…</span>
              </span>
            ) : (
              'Get full access for $20/year'
            )}
          </button>

          <p className="checkout-microcopy">
            Cancel anytime. No ads.
          </p>

          {/* Bottom links / legal */}
          <div className="checkout-legal-row">
            <button
              type="button"
              className="checkout-legal-link"
              onClick={() => (window.location.href = '/termsofservice')}
            >
              Terms
            </button>
            <span className="checkout-legal-separator">•</span>
            <button
              type="button"
              className="checkout-legal-link"
              onClick={() => (window.location.href = '/privacypolicy')}
            >
              Privacy
            </button>
          </div>

          {error && <div className="checkout-error">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default Checkout;
